"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationEntity = void 0;
const class_transformer_1 = require("class-transformer");
class OrganizationEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    name;
    slug;
    description;
    website;
    logoUrl;
    email;
    phone;
    industry;
    size; // 'startup', 'small', 'medium', 'large', 'enterprise'
    country;
    city;
    address;
    zipCode;
    taxId;
    plan;
    status;
    maxUsers;
    currentUserCount;
    ownerId;
    admins; // User IDs
    members; // User IDs
    metadata;
    billing;
    settings;
    branding;
    apiKeys;
    isActive;
    isVerified;
    verifiedAt;
    createdAt;
    updatedAt;
    deletedAt;
    // Relación con usuarios
    invitedUsers;
    // Configuración de notificaciones
    notifications;
    // Límites y cuotas
    limits;
    // Información de facturación
    billingInfo;
    // Configuración de seguridad
    security;
    // Estadísticas
    stats;
}
exports.OrganizationEntity = OrganizationEntity;
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], OrganizationEntity.prototype, "ownerId", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Object)
], OrganizationEntity.prototype, "billing", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], OrganizationEntity.prototype, "apiKeys", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], OrganizationEntity.prototype, "deletedAt", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Array)
], OrganizationEntity.prototype, "invitedUsers", void 0);
